export default __webpack_public_path__ + "static/media/WHITTIER DISTRIC LOGO_outlined-05.b47527d0.jpg";